/**
 * @author Kuitos
 * @since 2020-10-13
 */
export { patchLooseSandbox } from './forLooseSandbox';
export { patchStrictSandbox } from './forStrictSandbox';


//////////////////
// WEBPACK FOOTER
// ./node_modules/qiankun/es/sandbox/patchers/dynamicAppend/index.js
// module id = 610
// module chunks = 0